import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export type PlantsRankingItemResponse = {
  plantId: string;
  plantName: string;
  plantImageName: string | undefined;
  storageCapacity: number;
  chargedEnergy: number | string;
  dischargedEnergy: number | string;
  energyThroughput: number | string;
};

export type PlantsRankingResponse = PlantsRankingItemResponse[];

export const useGetPlantsRankingQuery = () => {
  return useQuery({
    queryKey: ['plants', 'ranking'],
    queryFn: async () => {
      const { data } = await client.get<{ body: PlantsRankingResponse }>(`/plants/ranking`);

      return data.body;
    },
    refetchInterval: 1000 * 60 * 5,
  });
};
